<template>
  <list>
    <div class="item-header">
      {{ $l.eventEntryStatus }}
    </div>

    <template v-if="entries.length === 0">
      <div class="item">
        <div class="item-right">
          {{ $l.eventNoEntry }}
        </div>
      </div>
    </template>

    <template v-else>
      <div v-for="e in entries" class="item" :key="e.id">
        <event-name :event="e.get('event')" />
        <div class="item-right">
          {{ e.get('allowed').get(locale) }}
        </div>
      </div>
    </template>
  </list>
</template>

<script>
import MixinLocale from '@/components/MixinLocale'
import List from '@/components/List'
import EventName from '@/components/Home/EntryStatusEventName'

export default {
  mixins: [
    MixinLocale
  ],

  components: {
    List,
    EventName
  },

  created: function () {
    this.$store.dispatch('entry/retrieveEntries')
  },

  computed: {
    entries: function () {
      return this.$store.state.entry.entries
    }
  }
}
</script>
